var React = require('react');

function ArrowRight12x12 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Size=12x12, Hover=Off, Inverted=off","stroke":"currentColor","strokeWidth":"2"},[React.createElement("path",{"id":"Vector","d":"M6 11l5-4.5v-1L6 1","strokeMiterlimit":"10","strokeLinecap":"round","key":0}),React.createElement("path",{"id":"Vector_2","d":"M0 6h11","strokeLinejoin":"bevel","key":1})]));
}

ArrowRight12x12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = ArrowRight12x12;

ArrowRight12x12.default = ArrowRight12x12;
